import {
    ConfirmationAlternative,
    ConfirmationModal,
} from "@design-system/Modal/ConfirmationModal";
import { ScheduleChangeCopy } from "./scheduleChangeCopy";

interface Props {
    show: boolean;
    copy: ScheduleChangeCopy | null;
    confirmLabel: string;
    /** Remove offers a second, hard-delete answer beside the reversal one. */
    alternative?: ConfirmationAlternative;
    onConfirm: () => Promise<void>;
    onDismiss: () => void;
}

/** PRO-11569: one centered confirm for both Replace and Remove. */
export const ScheduleChangeConfirmationModal = ({
    show,
    copy,
    confirmLabel,
    alternative,
    onConfirm,
    onDismiss,
}: Props) => (
    <ConfirmationModal
        show={show}
        title={copy?.title ?? ""}
        question={copy?.question ?? ""}
        yes={confirmLabel}
        alternative={alternative}
        onConfirm={onConfirm}
        onHide={onDismiss}
    />
);
